import { createApp } from 'vue'
import App from './App.vue'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入状态管理
import { setupStore } from '@/stores'

// 引入路由
import { setupRouter } from './router'

// 引入全局组件
import { setupComponent } from '@/components/index'

// 引入全局指令
import { setupDirectives } from '@/directives/index'

// 引入初始化样式
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

// 引入全局样式
import '@/styles/index.scss'

// 引入svg注册脚本
import 'virtual:svg-icons-register'

// 引入event bus
import { setupMitt } from '@/plugins/mitt'

// 注入全局方法
import { setupGlobalProperties } from '@/global/index'

// 引入sentry
import { setupSentry } from '@/plugins/sentry'

import { showVconsole } from '@/utils/vconsole'

showVconsole()

// 创建实例
const app = createApp(App)

const setupAll = () => {
  setupStore(app)

  setupRouter(app)

  setupElementPlus(app)

  setupComponent(app)

  setupDirectives(app)

  setupGlobalProperties(app)

  setupMitt(app)

  setupSentry(app)

  app.mount('#app')
}
setupAll()

export { app }
